var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "kiosk-input-wrapper" },
    [
      _c(
        "div",
        {
          staticClass: "slot-container",
          on: { focusin: _vm.onFocusIn, focusout: _vm.onFocusOut },
        },
        [_vm._t("default")],
        2
      ),
      _c("transition", { attrs: { name: "expand" } }, [
        _vm.showKeyboard
          ? _c(
              "div",
              {
                staticClass: "webkeyboard",
                on: {
                  mousedown: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              _vm._l(_vm.currentLayout, function (row, rIdx) {
                return _c(
                  "div",
                  { key: rIdx, staticClass: "keyboard-row" },
                  _vm._l(row, function (key) {
                    return _c(
                      "button",
                      {
                        key: key,
                        staticClass: "key-btn",
                        class: _vm.getKeyClass(key),
                        on: {
                          click: function ($event) {
                            return _vm.handleKeyPress(key)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.displayKey(key)) + " ")]
                    )
                  }),
                  0
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }